import img2 from "../../images/2.Pilotage.jpg";
import img1 from "../../images/1Une installation innovante.jpg";
import img3 from "../../images/Paysage.jpg";
import img4 from "../../images/5-Environnement.jpg";
import img5 from "../../images/4-espace_pedagogique.jpg";

import IconsList from "./IconsList";

import users from "../../images/icons/users.png";
import euro from "../../images/icons/num1.png";
import hydraeau from "../../images/icons/icon14.png";
import commune from "../../images/icons/icon12.png";
import time from "../../images/icons/time.png";
import { Button } from "../../components/ui/button";
import { Link } from "react-router-dom";

const InteractiveCarte = () => {
  return (
    <div>
      <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 mt-6 mb-6 md:grid-cols-2">
          <div className="flex flex-col justify-center">
            <h2 className="text-xl font-black text-left text-black">
              Une installation innovante
            </h2>
            <p className="mt-2 text-base text-left">
              Située sur les communes de Saint-Cyr-l'École et de Bailly, cette
              usine traite les eaux usées et pluviales de 14 communes de la
              plaine de Versailles. Récemment rénovée, elle dispose depuis 2017
              de la plus grande unité de traitement membranaire d'Europe, une
              technologie innovante de séparation finale, sans ajout de produits
              chimiques, qui garantit une épuration de l'eau à un niveau
              supérieur aux traitements classiques.
            </p>
            <div className="mt-4">
              <h2 className="text-xl font-black text-left text-black">
                Les eaux usées et pluviales sont assainies grâce à différentes
                étapes :
              </h2>
              <ul className="mt-2 ml-6 text-base list-disc">
                <li>
                  Le dégrillage débarrasse les eaux des déchets les plus
                  volumineux.
                </li>
                <li>
                  Le dessablage/déshuilage : élimine les graisses et sables par
                  aération et décantation.
                </li>
                <li>
                  Le traitement biologique : des bactéries consomment carbone,
                  azote et phosphore encore présents.
                </li>
                <li>
                  Le traitement membranaire : 180 000 m² de membranes immergées
                  assurent la séparation entre boue et eau épurée.
                </li>
                <li>
                  La désodorisation : débarrasse l'air des gaz malodorants issus
                  des traitements.
                </li>
              </ul>
            </div>
          </div>

          <div className="relative">
            <img
              src={img1}
              alt="Installation innovante"
              className="w-full h-64 rounded-lg sm:h-80 md:h-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 ">
          <div
            className="h-64 bg-center bg-cover rounded-lg sm:h-80 md:h-96"
            style={{
              backgroundImage: `url(${img2})`,
              backgroundSize: "cover",
            }}
          ></div>
          <div className="flex flex-col justify-center ">
            <h2 className="text-xl font-bold text-left text-black">
              Hydreau 360, l'outil de pilotage
            </h2>
            <p className="mt-2 text-base text-left">
              Hydreau 360 intègre et agrège 70 000 données, produites en continu
              sur l'usine et ses réseaux, récoltées grâce à des capteurs et des
              sondes positionnés sur les ouvrages et les canalisations du
              système d'assainissement. Cet outil permet d'identifier tout type
              de dysfonctionnement afin d'anticiper et éviter les crises
              potentielles.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 mt-20 md:grid-cols-2">
          <div className="flex flex-col justify-center">
            <h2 className="text-xl font-black text-left text-black">
              Des installations parfaitement intégrées dans le paysage
            </h2>
            <p className="mt-2 text-base text-left">
              Entourée d'un écrin boisé, l'usine du Carré de Réunion s'intègre
              parfaitement dans la plaine classée du château de Versailles. Les
              aménagements du site ont fait l'objet d'une attention
              particulière. Située dans un vallon naturel, accentuée par les
              remblais ferroviaires avoisinants, l'usine affiche une hauteur
              maximum de 11 m. Construits en matériaux pérennes, ses nouveaux
              bâtiments sont couverts d'une toiture végétalisée et, vus de loin,
              se confondent avec l'environnement rural. Ils épousent les courbes
              de niveau parallèles au ru de Gally, comme pour mieux accompagner
              le paysage.
            </p>
            <div className="mt-3">
              <h2 className="text-xl font-black text-left text-black">
                Des nuisances limitées
              </h2>
              <p className="text-base">
                Le traitement des eaux usées peut générer des odeurs
                susceptibles d'importuner les habitants alentours. L'usine Carré
                de Réunion applique un traitement de biodésodorisation qui
                supprime les odeurs désagréables.
              </p>
            </div>
          </div>

          <div className="relative">
            <img
              src={img3}
              alt="Installations paysagées"
              className="object-cover w-full h-64 rounded-lg sm:h-80 md:h-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 mt-6 md:grid-cols-2">
          <div
            className="h-64 bg-center bg-cover rounded-lg sm:h-80 md:h-96"
            style={{
              backgroundImage: `url(${img5})`,
              backgroundSize: "cover",
            }}
          ></div>
          <div className="flex flex-col justify-center">
            <h2 className="text-xl font-bold text-left text-black">
              Un espace pédagogique pour le grand public
            </h2>
            <p className="mt-2 text-base text-left">
              La récente rénovation de l'usine du Carré de Réunion a donné lieu
              à la création d'un espace pédagogique à l'attention du public
              scolaire. Ce lieu convivial et lumineux propose aux jeunes des
              animations ludiques, pédagogiques et interactives pour tout
              comprendre sur le grand et le petit cycle de l'eau et les
              sensibiliser à une utilisation raisonnée de cette ressource
              précieuse.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-20">
        <IconsList
          headingTitle="Carré de Réunion en chiffres"
          title1="Capacité de traitement"
          val1="340 000 eq/habitants"
          img1={users}
          title2="Première référence européenne"
          val2="216 000 m2 de surface membranaire"
          img2={euro}
          title3="Réseau de transport connectés"
          val3="44 Km d'eaux usées et pluviales"
          img3={hydraeau}
          title4="Communes"
          val4="11"
          img4={commune}
          title5="Le site fonctionne"
          val5="24h/24"
          img5={time}
        />
      </div>
      <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 mt-6 mb-6 md:grid-cols-2">
          <div className="flex items-center justify-center">
            <div className="text-start">
              <h2 className="text-xl font-black text-black">
                Notre engagement pour l'environnement
              </h2>
              <p className="mt-2 text-base">
                Nos installations s'inscrivent dans une politique de reconquête
                de la qualité du milieu naturel de la région. Nous mettons en
                œuvre des procédés innovants qui permettent d'éliminer
                efficacement la pollution tout en préservant l'environnement.
              </p>
              <Link to={"/mediatheque/videos"} className="flex justify-start mt-5">
                <Button>Voir plus</Button>
              </Link>
            </div>
          </div>

          <div className="relative">
            <img
              src={img4}
              alt="Engagement environnemental"
              className="object-cover w-full h-64 rounded-lg sm:h-80 md:h-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractiveCarte;
